<template>
  <Modal
    v-model="visible"
    title="详情"
    width="1024"
    :closable="false"
    :mask-closable="false"
  >
    <div style="height: 400px">
      <Tabs type="card" @on-click="changeTab">
        <TabPane label="系统消息">
          <div>
            <DatePicker
              v-model="searchDate1"
              type="daterange"
              placement="bottom-end"
              placeholder="选择发送时间"
              style="width: 300px; margin-left: 300px"
            ></DatePicker>
            <Button type="primary" @click="queryGoods">查询</Button>

            <div style="overflow: auto; height: 280px">
              <Table
                :columns="columns1"
                :data="data1"
                :scroll="{ y: 100 }"
                height="280"
              >
              </Table>
            </div>
            <div style="margin: 10px; overflow: hidden">
              <div style="float: right">
                <Page
                  :total="total"
                  :page-size="10"
                  :current="current"
                  @on-change="changePage"
                ></Page>
              </div>
            </div>
          </div>
        </TabPane>
        <TabPane label="游戏记录">
          <div>
            <Col span="4">
              <Input v-model="searchRoomid1" placeholder="输入房间id"
            /></Col>
            <DatePicker
              v-model="searchDate1"
              type="daterange"
              placement="bottom-end"
              placeholder="选择游戏时间"
              style="width: 300px; margin-left: 300px"
            ></DatePicker>
            <Button type="primary" @click="queryGames">查询</Button>

            <div style="overflow: auto; height: 280px">
              <Table
                :columns="columns2"
                :data="data2"
                :scroll="{ y: 100 }"
                height="280"
              >
              </Table>
            </div>
            <div style="margin: 10px; overflow: hidden">
              <div style="float: right">
                <Page
                  :total="total2"
                  :page-size="50"
                  :current="current2"
                  @on-change="changePage2"
                ></Page>
              </div>
            </div>
          </div>
        </TabPane>
        <TabPane label="Coin记录">
          <Row type="flex" justify="center" class="code-row-bg">
            <Col span="4">
              <Input v-model="searchRoomid2" placeholder="输入房间id" />
            </Col>
            <Col span="4">
              <Select v-model="cointype2" placeholder="选择类型">
                <Option value="">全部</Option>
                <Option value="0">消费</Option>
                <Option value="1">收入</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="specificType2" placeholder="选择具体类型">
                <Option value="">全部</Option>
                <Option value="0">魔鬼城</Option>
                <Option value="1">三爪</Option>
                <Option value="2">二爪</Option>
                <Option value="3">推币机</Option>
                <Option value="4">游戏机</Option>
                <Option value="5">爆爆乐</Option>
                <Option value="6">金币传说</Option>
                <Option value="7">糖果派对</Option>
                <Option value="9">后台操作</Option>
                <Option value="10">分解</Option>
                <Option value="11">商城兑换</Option>
                <Option value="12">购买虚拟物品</Option>
                <Option value="14">勋章分解</Option>
                <Option value="15">任务获得</Option>
                <Option value="16">注册赠送</Option>
                <Option value="17">实名认证</Option>
                <Option value="18">等级提升</Option>
                <Option value="19">高等级vip福利币</Option>
                <Option value="21">支付宝充值</Option>
                <Option value="20">微信充值</Option>
                <Option value="22">苹果充值</Option>
                <Option value="30">主播邀请</Option>
                <Option value="31">邀请付费充值奖励</Option>
                <Option value="32">游戏JP奖励</Option>
                <Option value="33">能量换币</Option>
                <Option value="34">商城退回</Option>
                <Option value="100">周卡赠送</Option>
                <Option value="101">月卡赠送</Option>
              </Select>
            </Col>
            <Col span="6">
              <DatePicker
                v-model="searchDate3"
                type="daterange"
                placement="bottom-end"
                placeholder="选择游戏时间"
              ></DatePicker>
            </Col>
            <Col span="4">
              <Button type="primary" @click="queryCoinChange">查询</Button>
            </Col>
          </Row>

          <div>
            <div style="overflow: auto; height: 280px">
              <Table
                :columns="columns3"
                :data="data3"
                :scroll="{ y: 100 }"
                height="280"
              >
              </Table>
            </div>
            <div style="margin: 10px; overflow: hidden">
              <div style="float: right">
                <Page
                  :total="total3"
                  :page-size="20"
                  :current="current3"
                  @on-change="changePage3"
                ></Page>
              </div>
            </div>
          </div>
        </TabPane>
        <TabPane label="背包">
          <div>
            <Col span="4">
              <Select v-model="boxtype4">
                <Option value="">全部</Option>
                <Option value="0">在背包</Option>
                <Option value="1">分解成币</Option>
                <Option value="2">申请发货</Option>
                <Option value="3">分解成能量</Option>
              </Select>
            </Col>
            <DatePicker
              v-model="searchDate4"
              type="daterange"
              placement="bottom-end"
              placeholder="选择游戏时间"
              style="width: 300px; margin-left: 300px"
            ></DatePicker>
            <Button type="primary" @click="queryBox">查询</Button>

            <div style="overflow: auto; height: 280px">
              <Table
                :columns="columns4"
                :data="data4"
                :scroll="{ y: 100 }"
                height="280"
              >
              </Table>
            </div>
            <div style="margin: 10px; overflow: hidden">
              <div style="float: right">
                <Page
                  :total="total4"
                  :page-size="50"
                  :current="current4"
                  @on-change="changePage4"
                ></Page>
              </div>
            </div>
          </div>
        </TabPane>
        <TabPane label="能量记录">
          <Row type="flex" justify="center" class="code-row-bg">
            <Col span="6">
              <DatePicker
                v-model="searchDate5"
                type="daterange"
                placement="bottom-end"
                placeholder="选择游戏时间"
              ></DatePicker
            ></Col>
            <Col span="4">
              <Button type="primary" @click="queryIntegralChange">查询</Button>
            </Col>
          </Row>

          <div>
            <div style="overflow: auto; height: 280px">
              <Table
                :columns="columns5"
                :data="data5"
                :scroll="{ y: 100 }"
                height="280"
              >
              </Table>
            </div>
            <div style="margin: 10px; overflow: hidden">
              <div style="float: right">
                <Page
                  :total="total5"
                  :page-size="20"
                  :current="current5"
                  @on-change="changePage5"
                ></Page>
              </div>
            </div>
          </div>
        </TabPane>
        <TabPane label="充值记录">
          <Row type="flex" justify="center" class="code-row-bg">
            <Col span="6">
              <DatePicker
                v-model="searchDate6"
                type="daterange"
                placement="bottom-end"
                placeholder="选择充值时间"
              ></DatePicker
            ></Col>
            <Col span="4">
              <Button type="primary" @click="queryRechange">查询</Button>
            </Col>
          </Row>

          <div>
            <div style="overflow: auto; height: 280px">
              <Table
                :columns="columns6"
                :data="data6"
                :scroll="{ y: 100 }"
                height="280"
              >
              </Table>
            </div>
            <div style="margin: 10px; overflow: hidden">
              <div style="float: right">
                <Page
                  :total="total6"
                  :page-size="20"
                  :current="current6"
                  @on-change="changePage6"
                ></Page>
              </div>
            </div>
          </div>
        </TabPane>
      </Tabs>
    </div>
    <div slot="footer">
      <Button @click="guanbimodal">取消</Button>
    </div>
  </Modal>
</template>

<script>
import {
  cmsUserMessage,
  cmsUserGamelist,
  cmsCoinChange,
  cmsUserBoxList,
  cmsIntegralChange,
  cmsRechange,
} from "../../api/user";

export default {
  data() {
    return {
      searchDate1: [],
      searchDate1: [],
      searchDate3: [],
      searchDate4: [],
      searchDate5: [],
      searchDate6: [],
      data1: [], // 用于存储查询结果
      columns1: [
        {
          title: "发送时间",
          key: "createtime",
        },
        {
          title: "消息内容",
          key: "msg_value",
        },
        {
          title: "申请类型",
          key: "msg_type",
          render: (h, params) => {
            const msg_type = params.row.msg_type;
            return h("span", msg_type === 0 ? "未读" : "已读");
          },
        },
      ],
      data2: [], // 用于存储查询结果
      columns2: [
        {
          title: "上机时间",
          key: "uptime",
        },
        {
          title: "下机时间",
          key: "downtime",
        },
        {
          title: "房间号",
          key: "roomid",
        },
        {
          title: "房间名",
          key: "roomname",
        },
        {
          title: "房间别名",
          key: "broomname",
        },
        {
          title: "上机前金币",
          key: "upmoney",
        },
        {
          title: "花费金币",
          key: "coinnumber",
        },
        {
          title: "奖励",
          key: "wincoin",
          render: (h, params) => {
            const wingift = params.row.wingift;
            const wingiftname = params.row.wingiftname;
            const gametype = params.row.machinetype;

            if (gametype == 1 || gametype == 2) {
              //娃娃机为礼品
              if (wingift == 0) {
                return h("span", "未中奖");
              } else {
                return h("span", wingiftname + ";id:" + wingift);
              }
            }
            if (gametype == 3 || gametype == 4) {
              //推币机为能量
              return h("span", params.row.winintegral);
            } else if (
              gametype == 0 ||
              gametype == 5 ||
              gametype == 6 ||
              gametype == 7
            ) {
              //魔鬼城为金币
              return h(
                "span",
                "金币:" +
                  params.row.wincoin +
                  ";礼品:" +
                  params.row.wingiftname +
                  "*" +
                  (params.row.wingiftnum == null ? "0" : params.row.wingiftnum),
              );
            } else {
              return h("span", "未知");
            }
          },
        },
        {
          title: "奖励类型",
          key: "wintype",
          render: (h, params) => {
            const gametype = params.row.machinetype;
            var type = "";
            switch (gametype) {
              case 0:
                type = "魔鬼城";
                break;
              case 5:
                type = "爆爆乐";
                break;
              case 6:
                type = "金币传说";
                break;
              case 7:
                type = "糖果派对";
                break;
              case 1:
                type = "礼品";
                break;
              case 2:
                type = "礼品";
                break;
              case 3:
                type = "能量";
                break;
              case 4:
                type = "能量";
                break;
            }
            return h("span", type);
          },
        },

        {
          title: "游戏类型",
          key: "gametype",
          render: (h, params) => {
            const gametype = parseInt(params.row.machinetype);
            var type = "";
            switch (gametype) {
              case 0:
                type = "魔鬼城";
                break;
              case 1:
                type = "三爪";
                break;
              case 2:
                type = "二爪";
                break;
              case 3:
                type = "推币机";
                break;
              case 4:
                type = "游戏机";
                break;
              case 5:
                type = "爆爆乐";
                break;
              case 6:
                type = "金币传说";
                break;
              case 7:
                type = "糖果派对";
                break;
            }
            return h("span", type);
          },
        },
        {
          title: "游戏进度",
          key: "gamestate",
          render: (h, params) => {
            const gamestate = params.row.gamestate;
            return h("span", gamestate === 0 ? "游戏中" : "已结算");
          },
        },
      ],
      data4: [], // 用于存储查询结果
      columns4: [
        {
          title: "商品名",
          key: "goodsname",
        },
        {
          title: "商品id",
          key: "goodsid",
        },
        {
          title: "获取时间",
          key: "createtimes",
        },
        {
          title: "来源",
          key: "source",
          render: (h, params) => {
            const source = params.row.source;
            if (source == 0) {
              return h("span", "魔鬼城");
            } else if (source == 1) {
              return h("span", "三爪机");
            } else if (source == 2) {
              return h("span", "二爪机");
            } else if (source == 5) {
              return h("span", "爆爆乐");
            } else if (source == 6) {
              return h("span", "金币传说");
            } else if (source == 7) {
              return h("span", "糖果派对");
            } else if (source == 11) {
              return h("span", "商城兑换");
            } else if (source == 9) {
              return h("span", "系统充值");
            }
          },
        },
        {
          title: "房间号",
          key: "roomid",
        },
        {
          title: "状态",
          key: "nstatus",
          render: (h, params) => {
            const nstatus = params.row.nstatus;
            if (nstatus == 0) {
              return h("span", "背包中");
            } else if (nstatus == 1) {
              return h("span", "已分解");
            } else if (nstatus == 2) {
              const ordertype = params.row.ordertype;
              console.log("ordertype:" + ordertype);
              if (ordertype == 0) {
                return h("span", "待发货");
              } else if (ordertype == 1) {
                return h("span", "已发货");
              } else if (ordertype == 2) {
                return h("span", "退回");
              } else if (ordertype == 3) {
                return h("span", "订单废弃");
              } else {
                return h("span", "订单追回");
              }
            } else if (nstatus == 3) {
              return h("span", "已分解");
            } else if (nstatus == 4) {
              return h("span", "系统扣除");
            }
          },
        },
        {
          title: "分解时间/发货时间",
          key: "nstatus",
          render: (h, params) => {
            const nstatus = params.row.nstatus;
            if (nstatus == 0) {
              return h("span", "");
            } else if (nstatus == 1) {
              return h("span", params.row.splittimes);
            } else if (nstatus == 2) {
              return h("span", params.row.applytimes);
            } else if (nstatus == 3) {
              return h("span", params.row.splittimes);
            }
          },
        },
      ],
      boxtype4: "",
      searchRoomid1: "",
      searchRoomid2: "",
      cointype2: "",
      specificType2: "",
      data3: [], // 用于存储查询结果'
      datas3: [],
      columns3: [
        {
          title: "时间",
          key: "createtime",
        },
        {
          title: "类型",
          key: "type",
          render: (h, params) => {
            const type = params.row.type;
            return h("span", type === 0 ? "消费" : "收入");
          },
        },
        {
          title: "具体类型",
          key: "status",
          render: (h, params) => {
            const status = params.row.status;
            switch (status) {
              case 0:
                return h("span", "魔鬼城");
              case 1:
                return h("span", "三爪");
              case 2:
                return h("span", "二爪");
              case 3:
                return h("span", "推币机");
              case 4:
                return h("span", "游戏机");
              case 5:
                return h("span", "爆爆乐");
              case 6:
                return h("span", "金币传说");
              case 9:
                return h("span", "后台操作");
              case 10:
                return h("span", "分解");
              case 11:
                return h("span", "商城兑换");
              case 12:
                return h("span", "购买虚拟物品");
              case 14:
                return h("span", "勋章分解");
              case 15:
                return h("span", "任务获得");
              case 16:
                return h("span", "注册赠送");
              case 17:
                return h("span", "实名认证");
              case 18:
                return h("span", "等级提升");
              case 19:
                return h("span", "高等级vip福利币");
              case 21:
                return h("span", "支付宝充值");
              case 20:
                return h("span", "微信充值");
              case 22:
                return h("span", "苹果充值");
              case 30:
                return h("span", "主播邀请");
              case 31:
                return h("span", "邀请付费充值奖励");
              case 32:
                return h("span", "游戏JP奖励");
              case 33:
                return h("span", "能量换币");
              case 34:
                return h("span", "商城退回");
              case 100:
                return h("span", "周卡赠送");
              case 101:
                return h("span", "月卡赠送");
            }
          },
        },
        {
          title: "机器id",
          key: "machineId",
        },
        {
          title: "房间id",
          key: "roomid",
        },
        {
          title: "之前余额",
          key: "before",
        },
        {
          title: "金额",
          key: "amount",
          render: (h, params) => {
            const type = params.row.type;
            const amount = params.row.amount;
            return h("span", type === 0 ? "-" + amount : "+" + amount);
          },
        },
        {
          title: "之后余额",
          key: "after",
        },
        {
          title: "备注",
          key: "beizhu",
        },
      ],
      data5: [], // 用于存储查询结果
      columns5: [
        {
          title: "时间",
          key: "createtime",
        },
        {
          title: "类型",
          key: "type",
          render: (h, params) => {
            const type = params.row.type;
            return h("span", type === 0 ? "消费" : "收入");
          },
        },
        {
          title: "具体类型",
          key: "status",
          render: (h, params) => {
            const status = params.row.status;
            switch (status) {
              case 0:
                return h("span", "魔鬼城");
              case 1:
                return h("span", "三爪");
              case 2:
                return h("span", "二爪");
              case 3:
                return h("span", "推币机");
              case 4:
                return h("span", "游戏机");
              case 5:
                return h("span", "爆爆乐");
              case 6:
                return h("span", "金币传说");
              case 9:
                return h("span", "后台操作");
              case 10:
                return h("span", "分解");
              case 11:
                return h("span", "商城兑换");
              case 12:
                return h("span", "购买虚拟物品");
              case 14:
                return h("span", "勋章分解");
              case 15:
                return h("span", "任务获得");
              case 16:
                return h("span", "注册赠送");
              case 17:
                return h("span", "实名认证");
              case 18:
                return h("span", "等级提升");
              case 19:
                return h("span", "高等级vip福利币");
              case 21:
                return h("span", "支付宝充值");
              case 20:
                return h("span", "微信充值");
              case 22:
                return h("span", "苹果充值");
              case 30:
                return h("span", "主播邀请");
              case 31:
                return h("span", "邀请付费充值奖励");
              case 34:
                return h("span", "商城退回");
              case 100:
                return h("span", "周卡赠送");
              case 101:
                return h("span", "月卡赠送");
            }
          },
        },
        {
          title: "机器id",
          key: "machineId",
        },
        {
          title: "房间id",
          key: "roomid",
        },
        {
          title: "之前余额",
          key: "before",
        },
        {
          title: "金额",
          key: "amount",
          render: (h, params) => {
            const type = params.row.type;
            const amount = params.row.amount;
            return h("span", type === 0 ? "-" + amount : "+" + amount);
          },
        },
        {
          title: "之后余额",
          key: "after",
        },
        {
          title: "备注",
          key: "beizhu",
        },
      ],
      columns6: [
        {
          title: "套餐id",
          key: "rechangeid",
        },
        {
          title: "充值金额",
          key: "paymoney",
        },
        {
          title: "充值时间",
          key: "createtimes",
        },
        {
          title: "套餐类型",
          key: "ntype",
          render: (h, params) => {
            const type = params.row.ntype;
            return h(
              "span",
              type == 0
                ? "普通套餐"
                : type == 1
                ? "新手套餐"
                : type == 100
                ? "周卡"
                : type == 101
                ? "月卡"
                : "每日套餐",
            );
          },
        },
        {
          title: "充值方式",
          key: "npaytype",
          render: (h, params) => {
            const type = params.row.npaytype;
            return h(
              "span",
              type == 1 || type == 3 ? "支付宝" : type == 2 ? "苹果" : "微信",
            );
          },
        },
        {
          title: "币数",
          key: "coinnum",
        },
      ],
      data6: [], // 用于存储查询结果
      current6: 1,
      total6: 0,
      current5: 1,
      total5: 0,
      current2: 1,
      total2: 0,
      current3: 1,
      total3: 0,
      current4: 1,
      total4: 0,
      current: 1,
      total: 0,
    };
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    user_id: {
      type: String,
      required: true,
    },
  },
  watch: {
    visible(val) {
      if (val) {
        // 当模态框打开时，清空备注内容
        this.searchDate1 = [];
        this.searchDate3 = [];
        this.searchDate4 = [];
        this.data1 = [];
        this.current = 1;
        this.total = 0;
        this.queryGoods();
        this.data2 = [];
        this.current2 = 1;
        this.total2 = 0;
        this.data3 = [];
        this.current3 = 1;
        this.total3 = 0;
        this.searchRoomid1 = "";
        this.searchRoomid2 = "";
        this.cointype2 = "";
        this.specificType2 = "";
        this.data4 = [];
        this.current4 = 1;
        this.total4 = 0;
        this.boxtype4 = "";
        this.data5 = [];
        this.current5 = 1;
        this.total5 = 0;
        this.data6 = [];
        this.current6 = 1;
        this.total6 = 0;
      }
    },
  },
  mounted() {
    this.queryGoods();
  },
  methods: {
    queryRechange() {
      var starttime = "";
      var endtime = "";
      if (this.searchDate6.length > 0 && this.searchDate6[0] != "") {
        starttime = this.formatDate(this.searchDate6[0]);
        endtime = this.formatDate(this.searchDate6[1]);
      }
      const params = {
        user_id: this.user_id,
        starttime,
        endtime,
        page: this.current6,
      };
      cmsRechange(params)
        .then((response) => {
          this.data6 = response.data.rows; // 获取查询结果
          this.current6 = response.data.pagination.page; // 获取当前页
          this.total6 = response.data.pagination.total; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },
    queryIntegralChange() {
      var starttime = "";
      var endtime = "";
      if (this.searchDate5.length > 0 && this.searchDate5[0] != "") {
        starttime = this.formatDate(this.searchDate5[0]);
        endtime = this.formatDate(this.searchDate5[1]);
      }
      const params = {
        user_id: this.user_id,
        starttime,
        endtime,
        page: this.current5,
      };
      cmsIntegralChange(params)
        .then((response) => {
          this.data5 = response.data.data; // 获取查询结果
          this.current5 = response.data.pagination.currentPage; // 获取当前页
          this.total5 = response.data.pagination.total; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },
    queryCoinChange() {
      var starttime = "";
      var endtime = "";
      if (this.searchDate3.length > 0 && this.searchDate3[0] != "") {
        starttime = this.formatDate(this.searchDate3[0]);
        endtime = this.formatDate(this.searchDate3[1]);
      }
      const params = {
        user_id: this.user_id,
        roomid: this.searchRoomid2,
        type: this.cointype2 != "" ? this.cointype2 : null,
        status: this.specificType2 != "" ? this.specificType2 : null,
        starttime,
        endtime,
        page: this.current3,
      };
      cmsCoinChange(params)
        .then((response) => {
          this.data3 = response.data.data; // 获取查询结果
          this.datas3 = response.data.data2;
          this.current3 = response.data.pagination.currentPage; // 获取当前页
          this.total3 = response.data.pagination.total; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },

    queryBox() {
      var starttime = "";
      var endtime = "";
      if (this.searchDate4.length > 0 && this.searchDate4[0] != "") {
        starttime = this.formatDate(this.searchDate4[0]);
        endtime = this.formatDate(this.searchDate4[1]);
      }
      const params = {
        user_id: this.user_id,
        starttime,
        endtime,
        page: this.current4,
        nstatus: parseInt(this.boxtype4),
      };
      cmsUserBoxList(params)
        .then((response) => {
          this.data4 = response.data.rows; // 获取查询结果
          this.current4 = response.data.pagination.page; // 获取当前页
          this.total4 = response.data.pagination.total; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },
    queryGames() {
      var starttime = "";
      var endtime = "";
      if (this.searchDate1.length > 0 && this.searchDate1[0] != "") {
        starttime = this.formatDate(this.searchDate1[0]);
        endtime = this.formatDate(this.searchDate1[1]);
      }
      const params = {
        roomid: this.searchRoomid1,
        user_id: this.user_id,
        starttime,
        endtime,
        page: this.current2,
      };
      cmsUserGamelist(params)
        .then((response) => {
          this.data2 = response.data.rows; // 获取查询结果
          this.current2 = response.data.pagination.page; // 获取当前页
          this.total2 = response.data.pagination.total; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },
    changeTab(index) {
      if (index == 0 && this.data1.length == 0) {
        this.queryGoods();
      } else if (index == 1 && this.data2.length == 0) {
        this.queryGames();
      } else if (index == 2 && this.data3.length == 0) {
        this.queryCoinChange();
      } else if (index == 3 && this.data4.length == 0) {
        this.queryBox();
      } else if (index == 4 && this.data5.length == 0) {
        this.queryIntegralChange();
      } else if (index == 5 && this.data6.length == 0) {
        this.queryRechange();
      }
    },
    guanbimodal() {
      this.$emit("guanbimodal");
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    queryGoods() {
      var starttime = "";
      var endtime = "";
      if (this.searchDate1.length > 0 && this.searchDate1[0] != "") {
        starttime = this.formatDate(this.searchDate1[0]);
        endtime = this.formatDate(this.searchDate1[1]);
      }
      const params = {
        user_id: this.user_id,
        starttime,
        endtime,
        page: this.current,
      };
      cmsUserMessage(params)
        .then((response) => {
          this.data1 = response.data.rows; // 获取查询结果
          this.current = response.data.pagination.page; // 获取当前页
          this.total = response.data.pagination.total; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },
    changePage(e) {
      this.current = e;
      this.queryGoods(); // 直接调用查询函数，不用重复逻辑
    },
    changePage2(e) {
      this.current2 = e;
      this.queryGames(); // 直接调用查询函数，不用重复逻辑
    },
    changePage3(e) {
      this.current3 = e;
      this.queryCoinChange(); // 直接调用查询函数，不用重复逻辑
    },
    changePage4(e) {
      this.current2 = e;
      this.queryGames(); // 直接调用查询函数，不用重复逻辑
    },
    changePage5(e) {
      this.current5 = e;
      this.queryIntegralChange(); // 直接调用查询函数，不用重复逻辑
    },
    changePage6(e) {
      this.current6 = e;
      this.queryRechange(); // 直接调用查询函数，不用重复逻辑
    },
  },
};
</script>

<style scoped>
/* 添加一些样式，如果需要的话 */
</style>
